const host = window.location.hostname;

const isDevEnv =
	host.startsWith("local.") ||
	host.startsWith("dev.") ||
	host.startsWith("stage.");

function log(...args) {
	if (isDevEnv) {
		console.log(...args);
	}
}

function dir(...args) {
	if (isDevEnv) {
		console.dir(...args);
	}
}

function warn(...args) {
	if (isDevEnv) {
		console.warn(...args);
	}
}

function error(...args) {
	if (isDevEnv) {
		console.error(...args);
	}
}

export default {
	log,
	dir,
	warn,
	error,
};